import type { ScheduledCourse } from '@/app/types/course';
import type { ScheduleRevision } from '@/app/types/academicChangeSet';

export const feedbackCourse: ScheduledCourse = {
  id: '13403', baseId: '01640111', name: 'Precalc Part 1', campus: 'Busch', campuses: ['Busch'],
  day: 'Tuesday', time: '2:00 PM - 3:20 PM', section: '41', instructors: ['TBA'],
  meetingTimes: [
    { day: 'Tuesday', startMinute: 840, endMinute: 920, location: 'SEC 202', mode: 'LEC', campus: 'Busch' },
    { day: 'Wednesday', startMinute: 750, endMinute: 805, location: 'SEC 202', mode: 'RECIT', campus: 'Busch' },
    { day: 'Thursday', startMinute: 840, endMinute: 920, location: 'SEC 202', mode: 'LEC', campus: 'Busch' },
  ],
  class_number: '111', department: '640', credits: 2, isOpen: false, examCode: 'F',
};

export const feedbackRevision: ScheduleRevision = {
  id: 'fixture-revision-1', owner_id: 'fixture-owner', schedule_id: 'fixture-schedule', sequence: 1,
  snapshot: { name: 'Example schedule', term_id: 'fall-2026', is_public: false, classes: ['13403'], configuration: null },
  operations: [], summary: 'Existing schedule imported', source: 'import', content_hash: 'fixture', created_at: '2026-08-31T12:00:00Z',
};
